import {quarterOptions} from "@/common/define";

export class MinusPointModel {
    constructor(record) {
        this.id = record.id;
        this.reason = record.description;
        this.department  = record.department?.name;
        this.quarter = this.getQuarter(record.quarter, record.year)
        this.human = record.user?.name;
        this.minusPoint = record.point;
    }
    getQuarter(value, year) {
        if (!value || !year) return ''
        return `${quarterOptions[value-1].label}/${year}`
    }
}